import { render } from "./AcquirentiProdottiLista.vue?vue&type=template&id=fc223e94&scoped=true"
import script from "./AcquirentiProdottiLista.vue?vue&type=script&lang=js"
export * from "./AcquirentiProdottiLista.vue?vue&type=script&lang=js"

import "./AcquirentiProdottiLista.vue?vue&type=style&index=0&id=fc223e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc223e94"]])

export default __exports__